import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button, Modal, notification } from 'antd'

import ProcessCard from './ProcessCard'
import { examinationProgress, publicExamAllocation } from '../../common/request'
import ResponseCode from '../../common/response-code'
import { examinationAllocationMonitorMap } from '../../common/common'

function ExaminationAllocationProcess (props) {
  const selectedExam = useSelector(state => state.examInfo.selectedExam)
  const [monitorData, setMonitorData] = useState({})
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (selectedExam.id) {
      getMonitorData()
    }
  }, [selectedExam])

  useEffect(() => {
    setTableData(Object.keys(examinationAllocationMonitorMap).filter(key => {
      if (selectedExam.isCheck === 0) {
        return key !== 'check'
      } else {
        return key
      }
    }).map(key => {
      return {
        label: examinationAllocationMonitorMap[key].label,
        value: key,
        finished: key === 'check' ? monitorData['check'] && monitorData['checkTimePass'] : monitorData[key]
      }
    }))
  }, [monitorData])

  const getMonitorData = () => {
    examinationProgress({ id: selectedExam.id }).then(res => {
      if (res.code === ResponseCode.success) {
        setMonitorData(res.data)
      } else {
        Modal.error({
          title: '错误',
          content: res.msg
        })
      }
    }).catch(err => {
      console.error(err)
      Modal.error({
        title: '错误',
        content: '网络错误，查询考试安排进度失败'
      })
    })
  }

  const generateProcessMonitorItem = (list) => {
    return list.map(item => {
      return (
        <div className={ 'text-center' } key={ item.value }>
          <div className={ 'mb-2' }>{ item.label }</div>
          <div>
            {
              item.finished
                ? <span className="text-success">已配置</span>
                : <span className="text-danger">未配置</span>
            }
          </div>
        </div>
      )
    })
  }

  const handlePublishAction = () => {
    Modal.confirm({
      title: `${ props.examStatus.examinationStatus >= 2 ? '停止' : '发布' }考场安排`,
      content: `确定要${ props.examStatus.examinationStatus >= 2 ? '停止' : '发布' }考场安排吗？`,
      centered: true,
      onOk: () => {
        setLoading(true)
        publicExamAllocation({ id: selectedExam.id }).then(res => {
          setLoading(false)
          if (res.code === ResponseCode.success) {
            notification.success({
              message: '操作成功',
              description: `已${ props.examStatus.examinationStatus >= 2 ? '停止' : '发布' }考场安排`
            })
            props.updateExamStatus?.()
          } else {
            Modal.error({
              title: '错误',
              content: res.msg,
              centered: true
            })
          }
        }).catch(() => {
          setLoading(false)
          Modal.error({
            title: '网络错误',
            content: `${ props.examStatus.examinationStatus >= 2 ? '停止' : '发布' }考场安排失败`,
            centered: true
          })
        })
      }
    })
  }

  const disabledPublishExam = (list) => {
    return list.some(item => {
      return !item.finished
    })
  }

  return (
    <div>
      <ProcessCard
        title={ '发布考场安排' }
        headerBtnList={ <>
          {
            props.examStatus.examinationStatus >= 2
              ? <Button
                type={ 'primary' }
                loading={ loading }
                ghost
                danger
                onClick={ handlePublishAction }
              >停止考场安排</Button>
              : <Button
                type={ 'primary' }
                loading={ loading }
                disabled={ disabledPublishExam(tableData) }
                onClick={ handlePublishAction }
              >发布考场安排</Button>
          }
        </> }
      >
        <div className={ 'my-3 d-flex align-items-center justify-content-around' }>
          { generateProcessMonitorItem(tableData) }
        </div>
      </ProcessCard>
    </div>
  )
}

export default ExaminationAllocationProcess
